export const importDataTranslationEN = {
  ImportDataPage: {
    head_title: 'Register data import',
    description_1: '(FTProのデータ取り込み）',
    description_2: '以下のファイルを順番に取り込んでください。',
    description_3: '--------------------------------------------------',
    description_4: '１．メニューマスタ（TMS_MST_MENU.csv）',
    description_5: '２．メニュー構成マスタ（TMS_MST_MENUCONST.csv）',
    description_6: '３．ＭＬＵマスタ（TMS_MST_MLU.csv）',
    description_7: '--------------------------------------------------',
    description_8: '※【注意】パターンコードのCSVを取り込むようにしてください。',
    Button: {
      change_registration_pattern_name: 'Change registration pattern name',
      selected_files: 'File selected',
      file_upload: 'Upload file',
    },
    Message: {
      file_not_select: 'File is not selected',
      import_successfully: 'Successfully completed: Files import completed.',
      invalid_file_name: 'ファイル名が不正です。直してください',
    },
  },
  ChangeRegistrationPatternNameModal: {
    head_title: 'Change registration pattern name',
    Button: {
      save: 'Save',
    },
    Table: {
      Header: {
        pattern_number: 'Pattern Number',
        pattern_name: 'Pattern Name',
      },
    },
  },
};
